"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var _util = require("../../util");
var BLOCK_CLASS = 'revisions-revisor';
var bem = (0, _util.bemClass)(BLOCK_CLASS);
var Payee = function Payee(_ref) {
  var field = _ref.field,
    index = _ref.index,
    onPayeeRemove = _ref.onPayeeRemove,
    children = _ref.children;
  var displayName = field.clientWebDisplay || field.clientName;
  return /*#__PURE__*/_react.default.createElement("tr", {
    key: field.id,
    className: bem('payees')
  }, /*#__PURE__*/_react.default.createElement("td", {
    className: bem('payee-name')
  }, /*#__PURE__*/_react.default.createElement("div", null, displayName, /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    className: bem('remove-button', index === 0 && 'remove-button--hidden'),
    variant: "tertiary",
    onClick: function onClick() {
      return onPayeeRemove(index);
    }
  }, "remove"))), /*#__PURE__*/_react.default.createElement("td", null, children));
};
Payee.propTypes = {
  field: _propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    clientWebDisplay: _propTypes.default.string,
    clientName: _propTypes.default.string
  }).isRequired,
  index: _propTypes.default.number.isRequired,
  onPayeeRemove: _propTypes.default.func.isRequired,
  children: _propTypes.default.node.isRequired
};
var _default = Payee;
exports.default = _default;
